import ErrorPage from './error'

export { ErrorPage }
